import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { IdentityJourney } from "@/features/individuals/components/identity-journey"
import { describing } from "@/lib/subject"
import { countryQueries } from "@/queries/countries"
import { individualQueries } from "@/queries/individuals"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/edit/"
)({
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(countryQueries.list())
    await context.queryClient.ensureQueryData(
      individualQueries.detail(params.individualId)
    )
  },
  component: AddIdentityDocumentPage,
})

function AddIdentityDocumentPage() {
  const { individualId } = Route.useParams()
  const navigate = useNavigate()
  const { data: individual } = useSuspenseQuery(
    individualQueries.detail(individualId)
  )

  return (
    <IdentityJourney
      individualId={individualId}
      subject={describing(individual.firstName)}
      onFinished={() =>
        navigate({
          from: "/$organisation",
          to: "/$organisation/individuals/$individualId/identity",
          params: { individualId },
        })
      }
    />
  )
}
